export default {
  data: {
    widgets: [
      {is:'CourseProgressWidget'},
      {is: 'RecentlyGradedWidget'},
      {is: 'PortfolioWidget'}
    ],
    items: [{
      title: 'Coursework "Hello World" needs to be submitted',
      subtitle: 'From Style Guide',
      thumb: null,
      icon: 'assignment',
      link_title: 'Submit Coursework',
      link_path: '/',
      due_date: 'Jan 1st, 2020'
    },{
      title: 'Survey "Lorem Ipsum" needs to be submitted',
      subtitle: 'From Donec condimentum',
      thumb: null,
      icon: 'quiz',
      link_title: 'Submit Survey',
      link_path: '/',
      due_date: 'Jan 1st, 2020'
    },{
      title: 'Coursework "Suspendisse nec" needs to be submitted',
      subtitle: 'From Fusce maximus',
      thumb: null,
      icon: 'assignment',
      link_title: 'Submit Coursework',
      link_path: '/',
      due_date: 'Jan 1st, 2020'
    }]
  },
  components: {
    CourseProgressWidget: {
      template: '#course_progress_widget_template',
    },
    RecentlyGradedWidget: {
      template: '#recently_graded_widget_template',
    },
    PortfolioWidget: {
      template: '#portfolio_widget_template',
    }
  }
};
